import { render } from "./RegisterForm.vue?vue&type=template&id=197462c2&scoped=true&ts=true"
import script from "./RegisterForm.vue?vue&type=script&lang=ts"
export * from "./RegisterForm.vue?vue&type=script&lang=ts"

import "./RegisterForm.vue?vue&type=style&index=0&id=197462c2&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197462c2"]])

export default __exports__